import axios from './api';

/**
 * Rechnungsdaten des aktuellen Benutzers abrufen
 */
export const getInvoiceData = async () => {
  const response = await axios.get('/invoice-data');
  return response.data;
};

/**
 * Rechnungsdaten des aktuellen Benutzers speichern/aktualisieren
 */
export const saveInvoiceData = async (invoiceData) => {
  const response = await axios.post('/invoice-data', { invoiceData });
  return response.data;
};

/**
 * Rechnungsdaten des aktuellen Benutzers löschen
 */
export const deleteInvoiceData = async () => {
  const response = await axios.delete('/invoice-data');
  return response.data;
};
